"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkspaceRedirectService = void 0;
class WorkspaceRedirectService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getApiV1CompaniesWorkspaceRedirectStatus({ companyId, workspaceId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/companies/{companyId}/workspace/{workspaceId}/redirect/status',
            path: {
                companyId: companyId,
                workspaceId: workspaceId,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV1CompaniesWorkspaceRedirectLink({ companyId, workspaceId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/companies/{companyId}/workspace/{workspaceId}/redirect/link',
            path: {
                companyId: companyId,
                workspaceId: workspaceId,
            },
            errors: {
                303: `Redirect`,
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV2WorkspacesRedirectStatus({ workspaceId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v2/workspaces/{workspaceId}/redirect/status',
            path: {
                workspaceId: workspaceId,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV2WorkspacesRedirectLink({ workspaceId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v2/workspaces/{workspaceId}/redirect/link',
            path: {
                workspaceId: workspaceId,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
}
exports.WorkspaceRedirectService = WorkspaceRedirectService;
